import type { PropsWithChildren } from "react";

import { useTilt } from "@/4-components/animations/pointer";

/**
 * Wraps content in a card that tilts toward the cursor.
 *
 * `will-change` is applied on hover rather than always: `useTilt` no-ops on
 * touch and under reduced motion, so an unconditional hint promoted every card
 * on the page to its own compositor layer, on a phone, where it can never tilt,
 * for the whole session.
 */
export function TiltCard({ children, className, max }: PropsWithChildren<{ className?: string; max: number }>) {
  const ref = useTilt<HTMLDivElement>(max);
  return (
    <div ref={ref} className={`${className ?? ""} transition-transform duration-200 ease-out hover:[will-change:transform]`}>
      {children}
    </div>
  );
}
